module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "metode-pembayaran-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/metode-pembayaran'
      }
    }
  }, [_vm._v("List Metode Pembayaran")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("\n            " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Metode Pembayaran\n        ")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Metode Pembayaran\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("\n                        " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Metode\n                        Pembayaran\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                                " + _vm._s(message) + "\n                            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Bank")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bank_name),
      expression: "data.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bank_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Atas Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.account_name),
      expression: "data.account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "account_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nomor Rekening")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.account_number),
      expression: "data.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "account_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(
    _vm.data.description
  )) + "\n                                            karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar (Max 1MB)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.bank_logo) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.bank_logo
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.handleChangeBankLogo(
          $event
        )
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("\n                                            -- Pilih Status --\n                                        ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.PUBLISH
    }
  }, [_vm._v("\n                                            Publish\n                                        ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.UNPUBLISH
    }
  }, [_vm._v("\n                                            Unpublish\n                                        ")])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                            Simpan\n                        ")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("\n                            Update\n                        ")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53cb2058","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/MetodePembayaranForm.vue
// module id = 1989
// module chunks = 1